/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * The version of the OpenAPI document: 1.0.31
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChildGender } from './child-gender';


/**
 * Child data
 */
export interface TokenChild { 
    uuid: string;
    firstName: string;
    lastName: string;
    birthDate: string;
    gender?: ChildGender | null;
    /**
     * Version of this entity (how many times it was changed)
     */
    readonly revision: number;
    id: number;
    token: string;
}

